<template>
    <div>
        <div class="sub-lnb-menu">
            <ul class="sub-lnb-menu__list">
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==1}" @click="lnbFn(1)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step1')">Services Provided in the Ward and Precautions</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==2}" @click="lnbFn(2)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step2')">Preparation Items</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==3}" @click="lnbFn(3)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step3')">Doctor's Rounds</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==4}" @click="lnbFn(4)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step4')">Meal Information</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==5}" @click="lnbFn(5)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step5')">Patient Visit Guide and Precautions</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==6}" @click="lnbFn(6)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step6')">Other Matters</a>
                </li>
            </ul>
        </div>

        <!-- 대동맥 -->
        <div class="subSwiper info" v-if="$store.getters.getHost == 'H0006'">
            <swiper 
                :cssMode="true" 
                :navigation="{
                    nextEl: '.subSwiper-next',
                    prevEl: '.subSwiper-prev'
                }" 
                :pagination="{ clickable: true }" 
                :mousewheel="true" 
                :keyboard="true" 
                :modules="modules"
            >
                <swiper-slide>
                    <img src="/resource/img/info-img05.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img06.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img07.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img08.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="subSwiper-bth subSwiper-next"></div>
            <div class="subSwiper-bth subSwiper-prev"></div>
        </div>

        <!-- 뇌혈관 -->
        <div class="subSwiper info" v-else>
            <swiper 
                :cssMode="true" 
                :navigation="{
                    nextEl: '.subSwiper-next',
                    prevEl: '.subSwiper-prev'
                }" 
                :pagination="{ clickable: true }" 
                :mousewheel="true" 
                :keyboard="true" 
                :modules="modules"
            >
                <swiper-slide>
                    <img src="/resource/img/hospitalization01-brain.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/hospitalization02-brain.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/hospitalization03-brain.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="subSwiper-bth subSwiper-next"></div>
            <div class="subSwiper-bth subSwiper-prev"></div>
        </div>

        <div id="step1" class="step-item info">
            <h3 class="bullet01">Services Provided in the Ward and Precautions </h3>
            <h4 class="bullet02 type2 num1 depth">How to call in an emergency</h4>
            <p class="depth">
                If you need emergency or nursing assistance, press the emergency bell located next to the bed or on the wall of the bathroom or shower room and you will receive immediate assistance.
            </p>

            <h4 class="bullet02 type2 num2 depth">Wearing a bracelet</h4>
            <p class="depth">
                In order to identify patients accurately, all our patients must all patients must wear a patient identification bracelet. We use the bracelet to confirm each patient's name and registration number. if the bracelet becomes soiled or damaged, please notify the nursing station and we will replace it immediately. 
            </p>

            <h4 class="bullet02 type2 num3 depth">Preventing the disappearance or abduction of pediatric patients</h4>
            <p class="depth">
                Guardians are kindly requested to remain with their pediatric patients at all times to prevent the disappearance or abduction of pediatric patients.
            </p>

            <h4 class="bullet02 type2 num4 depth">
                If a patient shows any unusual signs (altered consciousness, chest pain, bleeding, convulsions), notify the medical staff or hospital staff immediately.
            </h4>

            <h4 class="bullet02 type2 num5 depth">Moving to a hospital room</h4>
            <p class="depth">
                Within the same level ward, moving to a preferred bed is not allowed for reasons such as patient safety (medication, blood collection, meal provision, treatment).
            </p>
        </div>
        <div id="step2" class="step-item info">
            <h3 class="bullet01">Preparation Items</h3>
            <div class="need-item">
                <div class="need-item__text">
                    <h4 class="bullet02 type2 num1 depth">Personal Items to Prepare</h4>
                    <p class="bullet03 depth font-main">Patient Identification (Required)</p>
                    <p class="bullet05 depth"> For Identity Verification - Mobile ID or Health Insurance Card Accepted</p>
                    <p class="bullet05 depth"> For Minor Patients - Family Relationship Certificate or Resident Registration Copy Can Be Used as a Substitute</p>
                    <p class="bullet05 depth font-sub"> National Health Insurance Act - "Patient Identity Verification System" Implementation (Effective May 20, 2024)</p>
                    <p class="bullet03 depth">Medications : Submit the prescription for current medications or the medication pouch with the medication name to the ward nurse's station.</p>
                    <p class="bullet03 depth">Personal Items : Toiletries, towels, closed-toe indoor slippers for patients (slippers or Crocs are not allowed), tissues, water cup, bedding for the guardian, and other personal items.</p>
                    <h4 class="bullet02 type2 num2 depth">Additional Notes</h4>
                    <p class="bullet03 depth">For Patients Scheduled for Surgery : Please ensure that nail care is completely removed.</p>
                    <p class="bullet03 depth">Personal Items:Toiletries, towels, closed-toe indoor slippers for patients (slippers or Crocs are not allowed), tissues, and other personal items such as bedding for the guardian.</p>
                    <p class="bullet03 depth">Prohibited Items for Safety and Infection Control : The use of humidifiers, electric kettles, electric blankets, fans, and any electrical or flammable materials is prohibited to prevent infection, fire, and safety accidents.</p>
                </div>
                <div class="need-item__img">
                    <img src="/resource/img/intensive--img01.png" alt="">
                </div>
            </div>
        </div>
        
        <div id="step3" class="step-item info">
            <h3 class="bullet01">Doctor's Rounds</h3>
            <p class="depth">Doctor's rounds are made from 8:00 to 10:00 and from 19:20 to 21:00, but they may vary depending on the circumstances of the department.</p>
        </div>
        <div id="step4" class="step-item info">
            <h3 class="bullet01">Meal Information</h3>
            <p class="bullet04 num1 depth">
                Breakfast is served from 7:00 to 8:00, lunch from 12:00 to 13:00, and dinner from 18:00 to 19:00. Please refrain from bringing in food or eating in the food court so as to ensure proper patient treatment and infection prevention. 
            </p>
            <p class="bullet04 num2 depth">
                Food storage in a refrigerator: Please store cooked foods, excluding fermented foods, for less than 24 hours as they may spoil if stored for a long period of time.
            </p>
            <p class="bullet04 num3 depth">
                If a patient wishes, the patient can choose to receive “special meals” that is not covered by national health insurance, in which case the patient will bear the full cost.
            </p>
        </div>
        <div id="step5" class="step-item info">
            <h3 class="bullet01">Patient Visit Guide and Precautions</h3>
            <p class="bullet04 num1 depth">
                To ensure the patient's rapid recovery, stability, and protection from infection, children under the age of 13 with weak immune systems are not allowed to visit the infectious disease ward or intensive care unit.
            </p>
            <p class="bullet04 num2 depth">
                Guardians with colds and contagious diseases are restricted from visiting patients. If the patient desires privacy or does not wish to meet a visitor, please notify the nursing office.
            </p>
            <p class="bullet04 num3 depth">
                Please cooperate in creating a list of visitors in order to manage the patients’ visitors.
            </p>
            <p class="bullet04 num4 depth"><span class="font-main">4.	Allowed visiting hours </span></p>
            <p class="bullet05 depth">Weekdays: 18:00 to 20:00</p>
            <p class="bullet05 depth">Weekends and public holidays: 10:00 to 12:00, 18:00 to 20:00</p>
            <p class="bullet05 depth">Visiting time is limited to 2 hours. Please refrain from visiting after 20:00.</p>
        </div>
        <div id="step6" class="step-item info">
            <h3 class="bullet01">Other Matters</h3>
            <h4 class="bullet02 type2 num1 depth">Convenience facilities</h4>
            <p class="depth">Ward: The ward comprises a public restroom, waste disposal room, soiled utility room, a shower room, a lounge, a Vending machine”s”, a water purifier, a microwave, and a multipurpose room.</p>
            <p class="depth">
                The hospital is equipped with diverse facilities including an unmanned medical fee payment machine, a video CD registration machine, a convenience store, a bank, a cafe, a food court, a bakery, medical equipment, and an unmanned parcel delivery box.
            </p>

            <h4 class="bullet02 type2 num2 depth">Separate garbage collection</h4>
            <p class="depth">
                Please separate and dispose of used alcohol swabs and gauze in a Designated medical waste container.
            </p>

            <h4 class="bullet02 type2 num3 depth">No smoking</h4>
            <p class="depth">
                For the health of patients and fire prevention, the entire hospital has been designated as a non-smoking area, so please cooperate by refraining from smoking.
            </p>

            <h4 class="bullet02 type2 num4 depth">Fire prevention and response methods </h4>
            <p class="depth">
                Please refrain from using portable Gas stoves, electric fans, and electric heaters in the ward, and do not bring in any flammable or combustible materials. In the event of a fire, please notify the nurse immediately and evacuate the premises via the evacuation room and emergency stairs as instructed by the hospital staff.
            </p>

            <h4 class="bullet02 type2 num5 depth">Walking Guidelines</h4>
            <p class="depth">
                In principle, walking outside the building is prohibited. However, if the nurse in charge gives permission and a guardian accompanies you, you can take a walk in the garden on the 4th floor of the building and the lawn square at the north gate. Please bring your cell phone with you when taking a walk and Return to your room by 6pm
            </p>

            <h4 class="bullet02 type2 num6 depth">Handling of complaints and grievances </h4>
            <p class="depth">
                If you have any questions, concerns, or compliments regarding your use of the hospital’s services, you can inform the hospital by visiting the Customer Satisfaction Center on the first floor, or via phone, the hospital website, or the customer feedback box.
            </p>

            <h4 class="bullet02 type2 num7 depth">Parking fees</h4>
            <p class="depth">
                Please refer to the parking fee information posted on the ward bulletin board.
            </p>

            <h4 class="bullet02 type2 num8 depth">Beware of loss and theft </h4>
            <p class="depth">
                <span class="font-main">Please do not keep any valuables or cash in the hospital room. </span>
                Assistive devices such as dentures, hearing aids, glasses, and contact lenses should be removed during examinations, procedures, and surgeries, and 
                <span class="font-main">
                    store them carefully in a safe place. The medical center will not assume responsibility for any loss caused by the patient's negligence.
                </span>
            </p>
            <div class="depth">
                <div class="bullet-wrap">
                    <span class="font-main">Management of Personal Belongings</span>
                    <!-- <ul class="bullet-list">
                        <li class="bullet-item">본인관리</li>
                        <li class="bullet-item">보호자관리</li>
                    </ul> -->
                </div>
                <p>If you remove your personal belongings for examination or treatment, please be careful not to lose it.  </p>
                <p>The medical center will not assume responsibility for any loss caused by the patient's negligence.</p>

                <!-- <ul class="bullet-list type2">
                    <li class="bullet-item">틀니</li>
                    <li class="bullet-item">보청기</li>
                    <li class="bullet-item">안경</li>
                    <li class="bullet-item">시계</li>
                    <li class="bullet-item">귀걸이</li>
                    <li class="bullet-item">목걸이</li>
                    <li class="bullet-item">반지</li>
                    <li class="bullet-item">팔찌</li>
                    <li class="bullet-item">발찌</li>
                    <li class="bullet-item">열쇠</li>
                    <li class="bullet-item">지갑</li>
                    <li class="bullet-item">신발</li>
                    <li class="bullet-item">옷</li>
                    <li class="bullet-item">기타</li>
                    <li class="bullet-item">해당무</li>
                </ul> -->
            </div>


            <h4 class="bullet02 type2 num9 depth">Religious facility information</h4>
            <p class="depth">
                As our hospital is a Christian hospital, the "Bangju(Ark) Church" on the 3rd floor of Building C holds a Sunday service at 10:00 on Sundays, a Wednesday service at 17:00 on Wednesdays, and a children’s/youth service at 10:00 on Thursdays. For inquiries about ward visits, faith counseling, or other religious services, please call the pastoral counseling office (+82-2-6986-5724). The pastoral counseling office and prayer room are located on the 3rd floor of Building C.
            </p>

            <h4 class="bullet02 type2 num10 depth">Issuance of various certificates</h4>
            <p class="depth">
                Please inform your doctor or nurse in advance of any necessary documents such as medical certificates, medical records, and image copies.
            </p>

            <h4 class="bullet02 type2 num11 depth">
                Our hospital respects and protects patients' rights and obligations throughout all treatment processes.
            </h4>
            <div class="table mt20">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:40%;">
                            <col style="width:40%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Patient's Rights</th>
                                <th>Patient’s Responsibilities</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num1">Right to receive medical care.</p>
                                </td>
                                <td class="left" rowspan="2">
                                    <p class="bullet04 num1">Obligation of trust and Respect medical professionals.</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num2">Right to information and right to self-determination</p>
                                </td>
                            </tr>


                            <tr>
                                <td class="left">
                                    <p class="bullet04 num3">Right to confidentiality.</p>
                                </td>
                                <td class="left" rowspan="3">
                                    <p class="bullet04 num2">Obligation not to seek treatment through improper means.</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num4">Right to request consultation and mediation.</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num5">Right to receive medical services in a safe medical environment.</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <h4 class="bullet02 type2 num12 depth mt30">Information on refusal of treatment </h4>
            <p class="depth">
                If a patient or guardian creates a situation that may constitute an obstruction of business or an insult, defamation or assault against a medical professional, thereby rendering that medical professional unable to carry out their medical duties normally, provided that such refusal is in accordance with the Medical Service Act and the Emergency Medical Service Act”
            </p>
            <h4 class="bullet02 type2 num13 depth">
                If a patient or guardian (visitor) commits an act of violence (verbal abuse, threats, disturbance, sexual violence, sexual harassment, damage to property, etc.) against a member of our medical staff, they may be subject to legal punishment in accordance with the relevant laws and regulations.
            </h4>

        </div>

    </div>
</template>
<script>
    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // Import Swiper styles
    import 'swiper/css';

    import 'swiper/css/navigation';
    import 'swiper/css/pagination';

    import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        setup() {
            return {
                modules: [Navigation, Pagination, Mousewheel, Keyboard],
            };
        },
        data() {
            return {
                lnbIndex: 1,
            };
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            scrollTo(id) {
                const element = document.getElementById(id);
                if (element) {
                    // 해당 요소의 위치와 크기 정보 가져오기
                    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

                    // 스크롤을 이동할 위치를 계산 (100px 추가)
                    const scrollToPosition = elementTop - 100;

                    // 계산된 위치로 부드럽게 스크롤
                    window.scrollTo({
                    top: scrollToPosition,
                    behavior: 'smooth'
                    });
                }
            },
            handleScroll() {
                const sections = document.querySelectorAll('.step-item');
                sections.forEach((section, index) => {
                    const rect = section.getBoundingClientRect();
                    // Check if the top of the section is within the viewport
                    if (rect.top <= 101 && rect.top <= window.innerHeight) {
                        this.lnbIndex = index + 1; // Update lnbIndex based on the section's position
                    }
                });
            },
            lnbFn(index) {
                this.lnbIndex = index; // Change the active index when clicking the menu
            },
        },
    };
</script>